import { render, staticRenderFns } from "./mrc_ess_noContent.vue?vue&type=template&id=5b6d3e8a&"
import script from "./mrc_ess_noContent.vue?vue&type=script&lang=js&"
export * from "./mrc_ess_noContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
